module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quantity-selection field"
  }, [_c('div', {
    staticClass: "quantity-selection--title"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
    staticClass: "quantity-selection--content"
  }, _vm._l((_vm.collection), function(value) {
    return _c('quantity-selection-item', {
      key: value.value,
      attrs: {
        "value": _vm.newValue,
        "item": value
      },
      on: {
        "change": _vm.change
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-775ea374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/QuantitySelection.vue
// module id = 1949
// module chunks = 0